function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { node, bool, string, oneOf, shape } from 'prop-types';
import { GEL_SPACING_HLF, GEL_SPACING, GEL_SPACING_DBL, GEL_SPACING_QUAD } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_1_SCREEN_WIDTH_MAX, GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_GROUP_2_SCREEN_WIDTH_MAX, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_GROUP_5_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import { getParagon, getLongPrimer, getPica, getDoublePica } from '@bbc/gel-foundations/typography';
import { C_EBON, C_METAL, C_SHADOW } from '@bbc/psammead-styles/colours';
import { getSansRegular, getSerifMedium } from '@bbc/psammead-styles/font-styles';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { grid } from '@bbc/psammead-styles/detection';
import ImageGridItem from './ImageStyles';
import TextGridItem from './TextStyles';
var PROMO_TYPES = oneOf(['top', 'regular', 'leading']);
var wrapperTopStoryStyles = "\n  @media (min-width: ".concat(GEL_GROUP_5_SCREEN_WIDTH_MIN, ") {\n    grid-template-columns: repeat(12, 1fr);\n  }\n");
var wrapperRegularStyles = "\n  @media (min-width: ".concat(GEL_GROUP_4_SCREEN_WIDTH_MIN, ") {\n    display: block;\n  }\n");
var wrapperStyles = {
  top: wrapperTopStoryStyles,
  regular: wrapperRegularStyles,
  leading: ''
};
var StoryPromoWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StoryPromoWrapper",
  componentId: "sc-1dvfmi3-0"
})(["position:relative;@supports (", "){display:grid;grid-template-columns:repeat(6,1fr);grid-column-gap:", ";@media (min-width:", "){grid-column-gap:", ";}", "}"], grid, GEL_SPACING, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_SPACING_DBL, function (_ref) {
  var promoType = _ref.promoType;
  return wrapperStyles[promoType];
});
var ImageContentsWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ImageContentsWrapper",
  componentId: "sc-1dvfmi3-1"
})(["position:relative;"]);
var mediaIndicatorStylesTopLeading = /*#__PURE__*/css(["position:absolute;bottom:0;> *{height:", ";padding:", " ", ";}"], GEL_SPACING_QUAD, GEL_SPACING, GEL_SPACING_HLF);
var mediaIndicatorStylesRegular = /*#__PURE__*/css(["@media (min-width:", "){position:absolute;bottom:0;}> *{@media (max-width:", "){height:1.25rem;padding:", " ", " 0;}height:", ";padding:", " ", ";}"], GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_GROUP_1_SCREEN_WIDTH_MAX, GEL_SPACING_HLF, GEL_SPACING_HLF, GEL_SPACING_QUAD, GEL_SPACING, GEL_SPACING_HLF);
/*
 These styles are to ensure we have the correct positioning
 & spacing of the Media Indicator over the Image in the Story Promo 
 */

var mediaIndicatorStyles = {
  top: mediaIndicatorStylesTopLeading,
  regular: mediaIndicatorStylesRegular,
  leading: mediaIndicatorStylesTopLeading
};
var ImageOverlayWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ImageOverlayWrapper",
  componentId: "sc-1dvfmi3-2"
})(["", ""], function (_ref2) {
  var promoType = _ref2.promoType;
  return mediaIndicatorStyles[promoType];
});

var headlineTopStoryTypography = function headlineTopStoryTypography(script) {
  return getParagon(script);
};

var headlineRegularTypography = function headlineRegularTypography(script) {
  return getPica(script);
};

var headlineLeadingStoryTypography = function headlineLeadingStoryTypography(script) {
  return getDoublePica(script);
};

var headlineTypography = function headlineTypography(script) {
  return {
    top: headlineTopStoryTypography(script),
    regular: headlineRegularTypography(script),
    leading: headlineLeadingStoryTypography(script)
  };
};

export var Headline = /*#__PURE__*/styled.h3.withConfig({
  displayName: "Headline",
  componentId: "sc-1dvfmi3-3"
})(["color:", ";margin:0;padding-bottom:", ";", " ", " ", " "], C_EBON, GEL_SPACING, function (_ref3) {
  var service = _ref3.service;
  return getSerifMedium(service);
}, function (_ref4) {
  var script = _ref4.script,
      promoType = _ref4.promoType;
  return script && headlineTypography(script)[promoType];
}, function (_ref5) {
  var promoHasImage = _ref5.promoHasImage;
  return !promoHasImage && "display: inline;";
});
Headline.propTypes = {
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  promoHasImage: bool,
  promoType: PROMO_TYPES
};
Headline.defaultProps = {
  promoHasImage: true,
  promoType: 'regular'
};
var summaryTopStoryStyles = "\n  @media (min-width: ".concat(GEL_GROUP_3_SCREEN_WIDTH_MIN, ") and (max-width: ").concat(GEL_GROUP_3_SCREEN_WIDTH_MAX, ") {\n    display: none;\n    visibility: hidden;\n  }\n");
var summaryRegularStyles = "\n  @media (max-width: ".concat(GEL_GROUP_2_SCREEN_WIDTH_MAX, ") {\n    display: none;\n    visibility: hidden;\n  }\n\n  @media (min-width: ").concat(GEL_GROUP_4_SCREEN_WIDTH_MIN, ") {\n    display: none;\n    visibility: hidden;\n  }\n");
var summaryStyles = {
  top: summaryTopStoryStyles,
  regular: summaryRegularStyles,
  leading: summaryRegularStyles
};
export var Summary = /*#__PURE__*/styled.p.withConfig({
  displayName: "Summary",
  componentId: "sc-1dvfmi3-4"
})(["", ";", " color:", ";margin:0;padding-bottom:", ";", " ", ""], function (_ref6) {
  var script = _ref6.script;
  return script && getLongPrimer(script);
}, function (_ref7) {
  var service = _ref7.service;
  return getSansRegular(service);
}, C_SHADOW, GEL_SPACING, function (_ref8) {
  var promoHasImage = _ref8.promoHasImage;
  return !promoHasImage && "padding-top: ".concat(GEL_SPACING, ";");
}, function (_ref9) {
  var promoType = _ref9.promoType;
  return summaryStyles[promoType];
});
Summary.propTypes = {
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  promoHasImage: bool,
  promoType: PROMO_TYPES
};
Summary.defaultProps = {
  promoHasImage: true,
  promoType: 'regular'
};
export var Link = /*#__PURE__*/styled.a.withConfig({
  displayName: "Link",
  componentId: "sc-1dvfmi3-5"
})(["position:static;color:", ";text-decoration:none;overflow-wrap:break-word;&:before{bottom:0;content:'';left:0;overflow:hidden;position:absolute;right:0;top:0;white-space:nowrap;z-index:1;}&:hover,&:focus{text-decoration:underline;}&:visited{color:", ";}"], C_EBON, C_METAL);

var StoryPromo = function StoryPromo(_ref10) {
  var image = _ref10.image,
      info = _ref10.info,
      promoType = _ref10.promoType,
      dir = _ref10.dir,
      displayImage = _ref10.displayImage,
      mediaIndicator = _ref10.mediaIndicator,
      mediaIndicatorIsInline = _ref10.mediaIndicatorIsInline,
      props = _objectWithoutProperties(_ref10, ["image", "info", "promoType", "dir", "displayImage", "mediaIndicator", "mediaIndicatorIsInline"]);

  var renderImage = displayImage && /*#__PURE__*/React.createElement(ImageGridItem, {
    dir: dir,
    promoType: promoType
  }, /*#__PURE__*/React.createElement(ImageContentsWrapper, null, image, mediaIndicator && /*#__PURE__*/React.createElement(ImageOverlayWrapper, {
    mediaIndicatorIsInline: mediaIndicatorIsInline,
    promoType: promoType
  }, mediaIndicator)));
  var renderText = /*#__PURE__*/React.createElement(TextGridItem, {
    promoType: promoType,
    dir: dir,
    displayImage: displayImage
  }, !displayImage && mediaIndicator, info);
  return /*#__PURE__*/React.createElement(StoryPromoWrapper, _extends({
    promoType: promoType
  }, props), promoType === 'leading' ? /*#__PURE__*/React.createElement(React.Fragment, null, renderText, renderImage) : /*#__PURE__*/React.createElement(React.Fragment, null, renderImage, renderText));
};

StoryPromo.propTypes = {
  dir: oneOf(['ltr', 'rtl']),
  image: node.isRequired,
  info: node.isRequired,
  promoType: PROMO_TYPES,
  displayImage: bool,
  mediaIndicator: node,
  mediaIndicatorIsInline: bool
};
StoryPromo.defaultProps = {
  dir: 'ltr',
  promoType: 'regular',
  displayImage: true,
  mediaIndicator: null,
  mediaIndicatorIsInline: false
};
export default StoryPromo;